import './AppVersion.css';

/**
 * A betöltött bundle verziója (.env REACT_APP_JS_VERSION)
 *
 * A build pillanatában beégetett érték, ezért ebből látszik, hogy a felhasználó
 * ténylegesen melyik bundle-t futtatja – a kényszerített frissítés ellenőrzéséhez.
 */
const AppVersion = () => {
  const version = process.env.REACT_APP_JS_VERSION;

  if (!version) {
    return '';
  }

  return <div className='app_version'>v{version}</div>;
};

export default AppVersion;
